/**
 * The Mandate shell's one answer when the signed-in person has no active
 * transition: the dashboard shows it, and so does every embedded platform page
 * (items, sessions, tools, lineage, reports), since the Individual Space those
 * pages read is created with the transition.
 */

import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

export function MandateNoTransition() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <Compass className="h-16 w-16 text-[var(--text-ter)] mb-6" />
      <h2 className="text-xl font-semibold text-[var(--text-pri)] mb-2">
        You don't have an active transition.
      </h2>
      <p className="text-[var(--text-ter)] text-sm max-w-md mb-6">
        Mandate helps you build your mandate — decision by decision — in your first 100 days.
      </p>
      <button
        onClick={() => navigate('/apps/mandate/setup')}
        className="bg-primary-600 hover:bg-primary-700 text-white font-medium px-4 py-2"
      >
        Start your transition →
      </button>
    </div>
  );
}
